import * as React from 'react';
import * as _ from 'lodash';
import { hashHistory } from 'react-router';
export default function () {
    function onClick1(count, e) {
        this.props.handleSaveClick(e);
    }
    function onClick2(count, e) {
        this.props.handleCancelClick(e);
    }
    function onClick3(count) {
        this.props.back();
    }
    function scopeCount4() {
        var count = this.props.featuresFiltersToBeDeletedCount;
        return React.createElement('div', { 'className': 'app-content-footer app-content-footer--fixed' }, React.createElement('div', { 'className': 'app-content-footer__buttons' }, count ? React.createElement('div', {
            'className': 'lightbox-save-button',
            'onClick': onClick1.bind(this, count),
            'key': '230'
        }, '\r\n      Save\r\n      ', count ? React.createElement('span', {
            'className': 'updateCount',
            'key': '345'
        }, count) : null) : null, count ? React.createElement('div', {
            'className': 'lightbox-cancel-button',
            'onClick': onClick2.bind(this, count),
            'key': '417'
        }, 'Cancel') : null, React.createElement('button', {
            'className': 'ui-button ui-button--blue',
            'onClick': onClick3.bind(this, count)
        }, React.createElement('span', { 'className': 'ui-button-text ui-button--uppercase' }, 'Filters Management'))), React.createElement('pre', {}));
    }
    return scopeCount4.apply(this, []);
}